import type React from 'react';
import kit from './kit.module.scss';

/**
 * Общая шапка страницы кабинета (как «Мои задачи»): белый блок, крошки, заголовок,
 * опционально подзаголовок и ряд «вкладки слева / действие справа» (children).
 * Всегда первый элемент <main>, поэтому позиция заголовка одинакова на всех страницах.
 * prod1: компактная шапка одной высоты на всех страницах - крошки и заголовок в одну строку каждая,
 * подзаголовок идет в строке крошек, ряд children на десктопе справа от заголовка.
 */
export const PageHead = ({
  crumb,
  title,
  sub,
  children,
  className,
}: {
  crumb?: React.ReactNode;
  title: React.ReactNode;
  sub?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}) => (
  <section className={className ? `${kit.listHead} ${kit.pageHead} ${className}` : `${kit.listHead} ${kit.pageHead}`} data-page-head=''>
    {crumb || sub ? (
      <p className={kit.pageHeadCrumb}>
        {crumb}
        {sub ? <span className={kit.pageHeadSub}>{sub}</span> : null}
      </p>
    ) : null}
    <h1 className={kit.listHeadTitle} title={typeof title === 'string' ? title : undefined}>
      {title}
    </h1>
    {children ? <div className={kit.listHeadRow}>{children}</div> : null}
  </section>
);
